import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { moduleSettings } from "../../../stores/module-settings.store";
import { setDangerouslyInnerHtml } from "../../../helpers/set-inner-html";
import { getTagManagerService } from "../../../services/tag-manager.service";
import { selectionStore } from "../../../stores/selection.store";
import { getLanguageSwitcherService } from "../../../services/language-switcher.service";
import { capitalize } from "../../../utils";
import styled from "styled-components";
import { GolContactNameField } from "./gol-contact-name-field";
import { GolContactPhoneField } from "./gol-contact-phone-field";
import { GolContactTextField } from "./gol-contact-text-field";
import { GolCheckField } from "./gol-check-field";
import {
  GolContactFormContext,
  GolContactInfoFormContext,
} from "./gol-contact-form-interfaces";
import { pendingBookingStore } from "../../../stores/pending-booking.store";
import { Countries } from "../../../assets/json/countries";
import { ErrorMessage } from "../../errors/message-error-view";
import { IFromStyle, PendingBookingContact } from "../../../types";
import { Title } from "../../title/title";
import ReactPixel from "react-facebook-pixel";
import { GolContactGenderSelection } from "./gol-contact-gender-selection";
import GolCountryPicker, { Country } from "./gol-country-picker";
import { contactInfoService } from "../../../services/contact-info-service";
import { requestParamsImpl } from "../../../services/request-params.service";
interface ContactFormProps {
  clazz?: string | undefined;
}

const ContactBloc = styled.div`
  display: flex;
  width: inherit;
  flex-wrap: wrap;
  padding: 4px;
  border-radius: 8px;
  /* white */
  background-color: ${(props) => props.theme.backgroundColor};
  margin-bottom: 5px;

  border: 1px solid #f8f8f8;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

  @media screen and (max-width: 980px) {
    height: inherit;
    width: 100%;
  }

  textarea::placeholder {
    font-size: 11.8px;
    line-height: 15px;
    color: ${(props) => props.theme.textColorDarken};
  }
`;
export const ConfirmationFormWrapper = styled.form<IFromStyle>`
border-radius: 0 8px 8px 8px;
  display: flex;
  padding: 4px;
  flex-wrap: wrap;
  width: 610px;
  min-height: ${(props) =>
    props.minHeight != undefined ? props.minHeight : "140px"};
  background-color: ${(props) => props.theme.backgroundTransparentWhite};
  &.disabled {
    pointer-events: none;
  }

  @media screen and (max-width: 980px) {
    align-items: center;
    max-width: 100%;
    height: inherit;
    width: inherit;
  }

  .displayFlex{
    display: flex;
  }

  .golFlexOne {
    flex: 1;
  }

  .golFlewDirectionResponsiveMode {
    @media screen and (max-width: 980px) {
      flex-direction: column;
    }
  }
}
`;

export const ConfirmationFormLayout = styled.div`
  display: flex;
  flex-flow: column wrap;
  max-width: 610px;
  /* align-content: center; */
  @media screen and (max-width: 980px) {
    /* align-items:center; */
    flex-wrap: wrap;
  }
`;

const FormInnerLine = styled.div`
  display: flex;
  justify-content: center;
  margin: 4px 36px;
  line-height: 15px;
  font-size: 12px;
`;

const PersonalDataLine = styled(FormInnerLine)`
  display: inline-block;
`;

const NewsletterLine = styled(FormInnerLine)`
  font-style: italic;
`;

const Legend = styled.span`
  font-size: 10px;
  margin-left: 6px;
`;

export const FormLine = styled.div`
  display: flex;
  flex-grow: 3;
  width: 100%;
  @media screen and (max-width: 980px) {
    flex-wrap: wrap;
  }
`;

export const ContactLine = styled(FormLine)`
  @media screen and (min-width: 980px) {
    .contactField {
      width: 50%;
      flex: auto;
    }
    &.cityPostcodeCountry .contactField {
      width: calc(100% / 3);
    }
  }

  .contactField {
    margin: 4px;
  }
`;

const GolContactGenderLine = styled(FormLine)`
  margin: 4px;
`;

const ContactForm = ({ clazz }: ContactFormProps) => {
  const customFields = moduleSettings.customFields;
  const displayAllergiesField = moduleSettings.diplayAllergiesField;
  const { t, i18n } = useTranslation();
  const [terms, setTerms] = useState("");
  const [policy, setPolicy] = useState("");
  const [fieldsInErrors, setFieldsInErrors] = useState<string[]>([]);
  const requiredFields = moduleSettings.requiredContactFields;
  const [gender, setGender] = useState(
    pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.gender
      : 0
  );
  const [showAcceptSms, setShowAcceptSms] = useState(
    requestParamsImpl.overwrittenMobilePhone()
      ? true
      : pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.mobile_phone
      : false
  );
  const [showAcceptEmail, setShowAcceptEmail] = useState(
    requestParamsImpl.overwrittenEmail()
      ? true
      : pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.email
      : false
  );
  let selectedCountry: Country | null = null as Country | null;
  let selectedCountryForAddress: Country | null = null as Country | null;

  if (pendingBookingStore.pendingBookingContact?.country !== undefined) {
    const country = Countries.find((country: any) => {
      return (
        country.label.toLowerCase() ===
        pendingBookingStore.pendingBookingContact.country?.toLowerCase()
      );
    });
    if (country) {
      selectedCountryForAddress = country;
    }
  }
  if (requestParamsImpl.overwrittenCountryCode()) {
    const country = Countries.find((country: any) => {
      return (
        country.code.toUpperCase() ===
        requestParamsImpl.overwrittenCountryCode()?.toUpperCase()
      );
    });
    if (country) {
      selectedCountry = country as Country;
    }
  }

  const newsLetterLine = t("instabook.contacts.unsubcribe_newletter");

  const isPreCatelanRestaurant = moduleSettings.isPreCatelanRestaurant;
  const customLabelSmsSpamRestaurantGroup: string | null =
    moduleSettings.customLabelSmsSpamRestaurantGroup;
  const isLeCastelletGroupRestaurant =
    moduleSettings.isLeCastelletGroupRestaurant;
  const legend = t("instabook.contacts.mandatory_fields");

  const form = useRef({
    gender: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.gender
      : "",
    firstname: pendingBookingStore.pendingBookingContact?.firstname
      ? pendingBookingStore.pendingBookingContact.firstname
      : requestParamsImpl.overwrittenFirstName()?.trim() ?? null,
    lastname: pendingBookingStore.pendingBookingContact?.lastname
      ? pendingBookingStore.pendingBookingContact.lastname
      : requestParamsImpl.overwrittenLastName()?.trim() ?? null,
    mobile_phone: pendingBookingStore.pendingBookingContact?.mobile_phone
      ? pendingBookingStore.pendingBookingContact.mobile_phone
      : requestParamsImpl.overwrittenMobilePhone()?.trim() ?? null,
    country_code: selectedCountry,
    email: pendingBookingStore.pendingBookingContact?.email
      ? pendingBookingStore.pendingBookingContact.email
      : requestParamsImpl.overwrittenEmail()?.trim() ?? null,
    birthday: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.birthday
      : "",
    company: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.company
      : "",
    message: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.message
      : "",
    allergies: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.allergies
      : "",
    terms: pendingBookingStore.acceptTerms,
    allergyTerms: pendingBookingStore.acceptAllergiesTerms,
    accept_sms_spam: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.accept_sms_spam
      : false,
    accept_email_spam: pendingBookingStore.pendingBookingContact
      ? pendingBookingStore.pendingBookingContact.accept_email_spam
      : false,
    country: selectedCountryForAddress,
    postcode: pendingBookingStore.pendingBookingContact?.postcode ?? "",
    extra_address:
      pendingBookingStore.pendingBookingContact?.extra_address ?? "",
    address: pendingBookingStore.pendingBookingContact?.address ?? "",
    city: pendingBookingStore.pendingBookingContact?.city ?? "",
  } as { [key: string]: any });

  useEffect(() => {
    const localeUrl = getLanguageSwitcherService().golLocaleFromSwitcher(
      i18n.language
    );
    setTerms(`${moduleSettings.disclaimerUrl}&locale=${localeUrl}`);
    setPolicy(
      `${moduleSettings.privacyPolicyUrl}&locale=${
        ["fr", "ca", "ch"].includes(localeUrl) ? "fr" : "en"
      }`
    );
    return () => {
      getLanguageSwitcherService().unregisterListeners();
    };
  }, [i18n.language]);

  const formContext = useContext(GolContactInfoFormContext);

  const {
    checkContactInfoFormValidity,
    setCheckContactInfoFormValidity,
    errorMsg,
    setValidContactInfo,
  } = formContext;

  useEffect(() => {
    if (checkContactInfoFormValidity) {
      checkFormValidity();
    }
  }, [checkContactInfoFormValidity]);

  useEffect(() => {
    const errorDetails = errorMsg != null ? errorMsg["errorDetails"] : null;
    if (errorDetails !== null) {
      if (errorDetails.hasOwnProperty("contact_info")) {
        const contactInfo = errorDetails["contact_info"];
        const fieldsInErrorFromUpdateReq = Object.keys(contactInfo);
        if (fieldsInErrorFromUpdateReq) {
          const updatedFieldsInErrors = [
            ...fieldsInErrors,
            ...fieldsInErrorFromUpdateReq,
          ];
          setFieldsInErrors(Array.from(new Set(updatedFieldsInErrors)));
          setCheckContactInfoFormValidity(false);
        }
      }
    }
  }, [errorMsg, t]);

  useEffect(() => {
    // @ts-ignore
    if (!form.current["country_code"]) {
      const pendingBookingCountryCode: string =
        pendingBookingStore.countryCode ??
        getLanguageSwitcherService().countryCodeForLocale(
          moduleSettings.restaurantCountryCode
        );
      const defaultCountry = Countries.find((country: any) => {
        return (
          country.code.toLowerCase() === pendingBookingCountryCode.toLowerCase()
        );
      });

      if (defaultCountry) {
        form.current = {
          ...form.current,
          country_code: defaultCountry,
        };
      }
    }
  }, [i18n.language]);

  useEffect(() => {
    getTagManagerService()?.pushTags("contact_info", {
      guests: selectionStore.guests,
    });
    ReactPixel.pageView();
  }, []);

  const handleFormChange = (event: {
    target: { name: any; value: any; checked: any; valueAsDate: any };
  }) => {
    // Get the name of the field that caused this change event
    // Get the new value of this field
    const { name, value, checked, valueAsDate } = event.target;
    let defaultValue = value || undefined;
    switch (name) {
      case "gender":
        setGender(Number(value));
        break;
      case "birthday":
        if (typeof valueAsDate.toISOString === "function") {
          defaultValue = valueAsDate.toISOString();
        }
        break;
      case "mobile_phone":
        setShowAcceptSms(defaultValue && defaultValue.length);
        break;
      case "email":
        setShowAcceptEmail(defaultValue && defaultValue.length);
        break;
      default:
        break;
    }

    // Update state
    // Assign new value to the appropriate form field
    form.current = {
      ...form.current,
      [name]: checked ? checked : defaultValue,
    };

    if ((defaultValue && defaultValue.length) || checked) {
      const array = [...fieldsInErrors];
      const index = array.indexOf(name);
      if (index !== -1) {
        array.splice(index, 1);
        setFieldsInErrors(Array.from(new Set(array)));
      }
    }
  };

  const requiredFieldsFilled = () => {
    let requiredFieldsInError: string[] = [];
    requiredFields.forEach((field) => {
      if (!fieldFilled(field)) {
        requiredFieldsInError.push(field);
      }
    });
    return requiredFieldsInError;
  };

  const fieldFilled = (field: string) => {
    let value = form.current[field];
    if (field === "terms") {
      return requestParamsImpl.overwrittenHideGeneralTerms() || value;
    }
    if (["allergyTerms"].includes(field)) {
      return value;
    }
    return typeof value !== "undefined" && value != null;
  };

  const requiredCustomFieldsFilled = () => {
    let requiredCustomFieldsInError: string[] = [];
    if (customFields.show_allergies_terms_on_module) {
      let field = "allergyTerms";
      if (!fieldFilled(field)) {
        requiredCustomFieldsInError.push(field);
      }
    }

    return requiredCustomFieldsInError;
  };
  const updatePendingContactInfo = () => {
    const {
      firstname,
      lastname,
      country_code,
      mobile_phone,
      email,
      message,
      allergies,
      birthday,
      company,
      terms,
      allergyTerms,
      country,
      address,
      extra_address,
      postcode,
      city,
      accept_email_spam,
      accept_sms_spam,
    } = form.current;
    const contact_info: PendingBookingContact = {
      firstname,
      lastname,
      mobile_phone,
      email: email ? email : "",
      message: message ? message : "",
      allergies: allergies ? allergies : "",
      birthday,
      country_code: "",
      address,
      extra_address,
      city,
      postcode,
      country,
      accept_sms_spam: accept_sms_spam ?? false,
      accept_email_spam: accept_email_spam ?? false,
    };

    if (!(mobile_phone && mobile_phone.length)) {
      contact_info.accept_sms_spam = false;
    }

    if (!(email && email.length)) {
      contact_info.accept_email_spam = false;
    }

    if (country_code !== null) {
      contact_info.country_code = country_code.code;
    }

    if (country !== null) {
      contact_info.country = country.label;
    }

    if (company && company.length) {
      contact_info.company = company;
    }

    if (gender && gender > 0) {
      contact_info.gender = gender;
    }

    pendingBookingStore.pendingBookingContact = contact_info;
    pendingBookingStore.acceptAllergiesTerms = allergyTerms;
    pendingBookingStore.acceptTerms = terms;
    setValidContactInfo(true);
  };
  const checkFormValidity = () => {
    let updatedFieldsInErrors = [
      ...fieldsInErrors,
      ...requiredFieldsFilled(),
      ...requiredCustomFieldsFilled(),
    ];
    setFieldsInErrors(Array.from(new Set(updatedFieldsInErrors)));
    if (updatedFieldsInErrors.length === 0) {
      updatePendingContactInfo();
    } else {
      setCheckContactInfoFormValidity(false);
    }
  };

  const value = {
    form: form.current,
    fieldsInErrors: fieldsInErrors,
    handleFormChange,
    requiredFields,
  };

  const genderOptions = contactInfoService.computeGenderOptions(gender);
  const addressSub = (
    <>
      <GolContactTextField
        name={"postcode"}
        label={t("instabook.contacts.postcode")}
        onChange={handleFormChange}
        value={form.current["postcode"]}
        clazz="contactField "
      />
      <GolContactNameField
        onChange={handleFormChange}
        name={"city"}
        clazz="contactField  "
        value={form.current["city"]}
      />
    </>
  );

  const countryPicker = (
    <GolCountryPicker
      id="country-picker"
      claszName="contactField golFlexOne"
      defaultValue={form.current["country"]}
      name="country"
      onChange={handleFormChange}
      label={t("instabook.contacts.country")}
      getOptionLabel={(option: Country) => option.label}
    />
  );
  const addressMain = (
    <>
      <ContactLine
        data-test="address"
        className="golFlewDirectionResponsiveMode"
      >
        <GolContactNameField name={"address"} clazz="contactField golFlexOne" />
        <GolContactNameField
          name={"extra_address"}
          clazz="contactField golFlexOne"
        />
      </ContactLine>
    </>
  );

  let labelSmsSpam;
  if (isPreCatelanRestaurant) {
    labelSmsSpam = (
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          "instabook.contacts.accept_sms_spam_pre_catelan"
        )}
      />
    );
  } else if (customLabelSmsSpamRestaurantGroup !== null) {
    labelSmsSpam = (
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          "instabook.contacts.accept_sms_spam_group",
          {
            restaurant: capitalize(customLabelSmsSpamRestaurantGroup),
          }
        )}
      />
    );
  } else {
    labelSmsSpam = (
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          "instabook.contacts.accept_sms_spam",
          {
            restaurant: isLeCastelletGroupRestaurant
              ? "L'Hôtel du Castellet"
              : capitalize(moduleSettings.getRestaurantName()),
          }
        )}
      />
    );
  }

  let labelEmailSpam;
  if (isPreCatelanRestaurant) {
    labelEmailSpam = (
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          "instabook.contacts.accept_email_spam_pre_catelan"
        )}
      />
    );
  } else if (customLabelSmsSpamRestaurantGroup !== null) {
    labelEmailSpam = (
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          "instabook.contacts.accept_email_spam_group",
          {
            restaurant: capitalize(customLabelSmsSpamRestaurantGroup),
          }
        )}
      />
    );
  } else {
    labelEmailSpam = (
      <span
        dangerouslySetInnerHTML={setDangerouslyInnerHtml(
          t,
          "instabook.contacts.accept_email_spam",
          {
            restaurant: isLeCastelletGroupRestaurant
              ? "L'Hôtel du Castellet"
              : capitalize(moduleSettings.getRestaurantName()),
          }
        )}
      />
    );
  }

  return (
    <ConfirmationFormLayout>
      <Title text={t("instabook.contacts.formLabel")} />
      <ConfirmationFormWrapper className={clazz}>
        {errorMsg && (
          <ErrorMessage error={errorMsg["error"]} status={errorMsg["status"]} />
        )}
        <GolContactFormContext.Provider value={value}>
          <ContactBloc>
            <GolContactGenderLine data-test="gender">
              {customFields.show_gender && (
                <GolContactGenderSelection
                  label={t("instabook.contacts.gender")}
                  name={"gender"}
                  onChange={handleFormChange}
                  options={genderOptions}
                />
              )}
            </GolContactGenderLine>
            <ContactLine
              data-test="firstname-lastname"
              className="golFlewDirectionResponsiveMode"
            >
              <GolContactNameField
                name={"firstname"}
                clazz="contactField golFlexOne"
              />
              <GolContactNameField
                name={"lastname"}
                clazz="contactField golFlexOne"
              />
            </ContactLine>
            <ContactLine
              data-test="mobileAndEmail"
              className="golFlewDirectionResponsiveMode"
            >
              <GolContactPhoneField clazz="golFlexOne" name={"mobile_phone"} />
              <GolContactNameField
                clazz="contactField golFlexOne"
                name={"email"}
              />
            </ContactLine>

            <ContactLine>
              {customFields.show_birthday && (
                <GolContactTextField
                  inputLabelProps={{ shrink: true }}
                  type="date"
                  onChange={handleFormChange}
                  clazz="contactField golFlexOne"
                  name="birthday"
                  label={t("instabook.contacts.birthday")}
                />
              )}
              {customFields.show_company && (
                <GolContactTextField
                  onChange={handleFormChange}
                  clazz="contactField golFlexOne"
                  name="company"
                  fullWidth={true}
                  multiline={true}
                  label={t("instabook.contacts.company")}
                  rows={4}
                />
              )}
            </ContactLine>
            {isPreCatelanRestaurant && (
              <Legend data-test="mandatory-fields-legend">{legend}</Legend>
            )}
          </ContactBloc>
          {(customFields.show_address || customFields.show_country) && (
            <ContactBloc>
              {customFields.show_address ? (
                customFields.show_country ? (
                  <>
                    {addressMain}
                    <ContactLine
                      data-test="cityPostcodeCountry"
                      className="golFlewDirectionResponsiveMode cityPostcodeCountry"
                    >
                      {addressSub}
                      {countryPicker}
                    </ContactLine>
                  </>
                ) : (
                  <>
                    {addressMain}
                    <ContactLine
                      data-test="cityPostcode"
                      className="golFlewDirectionResponsiveMode"
                    >
                      {addressSub}
                    </ContactLine>
                  </>
                )
              ) : undefined}

              {!customFields.show_address && customFields.show_country && (
                <ContactLine
                  className="golFlexOne"
                  data-test="countryAddressPicker"
                >
                  {countryPicker}
                </ContactLine>
              )}
            </ContactBloc>
          )}
          <ContactBloc>
            <ContactLine data-test="restaurant-message">
              {isPreCatelanRestaurant ? (
                <GolContactTextField
                  onChange={handleFormChange}
                  textSize="medium"
                  clazz="contactField"
                  name="message"
                  fullWidth={true}
                  multiline={true}
                  rowsMax={4}
                  label={t("instabook.contacts.message")}
                  placeholder={t("instabook.contacts.message_pre_catelan")}
                  inputLabelProps={{ shrink: true }}
                />
              ) : (
                <GolContactTextField
                  onChange={handleFormChange}
                  textSize="medium"
                  clazz="contactField"
                  name="message"
                  fullWidth={true}
                  multiline={true}
                  rowsMax={4}
                  label={t("instabook.contacts.message")}
                />
              )}
            </ContactLine>
            {displayAllergiesField && (
              <ContactLine>
                <GolContactTextField
                  onChange={handleFormChange}
                  textSize="medium"
                  clazz="contactField"
                  name="allergies"
                  fullWidth={true}
                  multiline={true}
                  rowsMax={4}
                  label={t("instabook.contacts.allergies")}
                  value={form.current["allergies"]}
                />
              </ContactLine>
            )}

            {customFields.show_allergies_terms_on_module && (
              <GolCheckField
                name="allergyTerms"
                label={
                  <span>{t("instabook.contacts.accept_allergies_terms")}</span>
                }
                controlName="allergyTerms"
                controlId={"allergies-terms"}
              />
            )}

            {!requestParamsImpl.overwrittenHideGeneralTerms() && (
              <GolCheckField
                name="terms"
                label={
                  <span
                    dangerouslySetInnerHTML={setDangerouslyInnerHtml(
                      t,
                      "instabook.contacts.accept_terms",
                      {
                        terms,
                      }
                    )}
                  />
                }
                controlName="terms"
                controlId={"terms"}
              />
            )}

            {showAcceptSms && (
              <GolCheckField
                clazz="contactField"
                name="accept_sms_spam"
                label={labelSmsSpam}
                controlName="accept_sms_spam"
                controlId={"accept_sms_spam"}
              />
            )}
            {showAcceptEmail && (
              <GolCheckField
                clazz="contactField"
                name="accept_email_spam"
                label={labelEmailSpam}
                controlName="accept_email_spam"
                controlId={"accept_email_spam"}
              />
            )}

            {customFields.accept_partner_spam && !isPreCatelanRestaurant && (
              <GolCheckField
                clazz="contactField"
                name="accept_partner_spam"
                label={
                  <span
                    dangerouslySetInnerHTML={setDangerouslyInnerHtml(
                      t,
                      "instabook.contacts.accept_spam",
                      {
                        partner: capitalize(moduleSettings.partnerName),
                      }
                    )}
                  />
                }
                controlName="accept_partner_spam"
                controlId={"accept_partner_spam"}
              />
            )}
            {customFields.show_tol_spam && !isPreCatelanRestaurant && (
              <GolCheckField
                clazz="contactField"
                name="show_tol_spam"
                label={
                  <span
                    dangerouslySetInnerHTML={setDangerouslyInnerHtml(
                      t,
                      "instabook.contacts.accept_tol_spam"
                    )}
                  />
                }
                controlName="show_tol_spam"
                controlId={"show_tol_spam"}
              />
            )}
            {(showAcceptEmail ||
              showAcceptSms ||
              customFields.accept_partner_spam) &&
            !isPreCatelanRestaurant ? (
              <NewsletterLine
                className="newsletter"
                data-test="unsubcribe-newsletter"
              >
                {newsLetterLine}
              </NewsletterLine>
            ) : (
              <></>
            )}

            <PersonalDataLine data-test="personal-data-line">
              {isPreCatelanRestaurant ? (
                showAcceptEmail || showAcceptSms ? (
                  <span
                    dangerouslySetInnerHTML={setDangerouslyInnerHtml(
                      t,
                      "instabook.contacts.privacy_info_pre_catelan"
                    )}
                  />
                ) : (
                  <></>
                )
              ) : (
                <span
                  dangerouslySetInnerHTML={setDangerouslyInnerHtml(
                    t,
                    "instabook.contacts.privacy_info",
                    { policy: policy }
                  )}
                />
              )}
            </PersonalDataLine>
          </ContactBloc>
        </GolContactFormContext.Provider>
      </ConfirmationFormWrapper>
    </ConfirmationFormLayout>
  );
};
export const ConfirmationContactForm = memo(ContactForm);
